import {Component, Input, DoCheck, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PlanModel} from '../../common/service/plan-model.model';
import {selectedPurpose} from '../../lodge-field-record/lodge-field-record.model';

@Component({
    selector: 'nlr-field-record-survey-details',
    imports: [FormsModule, CommonModule],
    templateUrl: './field-record-survey-details.component.html',
    styleUrl: './field-record-survey-details.component.scss'
})
export class FieldRecordSurveyDetailsComponent implements DoCheck, OnInit {
    specialSurveyAreaOptions = [];
    planModel: PlanModel = undefined;
    benchmarkConnectionsOptions = this.yesNoOptions();
    ssmGeodeticConnectionsOptions = this.yesNoOptions();
    unnamedGeodeticConnectionsOptions = this.yesNoOptions();
    previousPurpose = undefined;
    previousBenchmarkConnections = undefined;
    previousSsmGeodeticConnections = undefined;
    submitted = false;

    @Input()
    model: PlanModel;
    @Input()
    selectedPurpose: selectedPurpose;

    constructor() {}

    ngOnInit(): void {
        if (this.model.geodeticConnections === undefined) {
            this.model.geodeticConnections = [];
        }
    }

    isSpecialSurveyAreaValid() {
        return this.model.specialSurveyArea === undefined || this.model.specialSurveyArea === '' ? false : true;
    }

    isSsmGeodeticConnectionsValid() {
        return this.model.ssmGeodeticConnections === undefined || this.model.ssmGeodeticConnections === '' ? false : true;
    }

    isbenchmarkConnectionsValid() {
        return this.model.benchmarkConnections === undefined || this.model.benchmarkConnections === '' ? false : true;
    }

    isunnamedGeodeticConnectionValid() {
        return this.model.unnamedGeodeticConnection === undefined || this.model.unnamedGeodeticConnection === '' ? false : true;
    }

    isGeodeticConnectionNameValid(markType: string, index: number) {
        const geodeticConnectionName = this.model.geodeticConnections.filter(v => {
            return markType === 'SSM' ? v.markType === 'SSM' : v.markType === 'BM';
        })[index].name;
        return geodeticConnectionName === undefined || geodeticConnectionName === '' ? false : true;
    }

    ngDoCheck(): void {
        if (this.model.purpose !== this.previousPurpose) {
            this.previousPurpose = this.model.purpose;
            this.specialSurveyAreaOptions = this.toOptions((this.selectedPurpose.specialSurveyArea || '').split(','));

            if (this.model.specialSurveyArea) {
                delete this.model.specialSurveyArea;
            }

            if (this.model.ssmGeodeticConnections) {
                delete this.model.ssmGeodeticConnections;
            }

            if (this.model.benchmarkConnections) {
                delete this.model.benchmarkConnections;
            }

            if (this.model.unnamedGeodeticConnection) {
                delete this.model.unnamedGeodeticConnection;
            }

            if (this.specialSurveyAreaOptions.length === 1) {
                this.model.specialSurveyArea = this.specialSurveyAreaOptions[0].value;
            }
        }

        if (this.model.benchmarkConnections !== this.previousBenchmarkConnections) {
            this.previousBenchmarkConnections = this.model.benchmarkConnections;
            this.removeAllBmConnections();
            if (this.model.benchmarkConnections) {
                this.addBmConnection();
            }
        }
        if (this.model.ssmGeodeticConnections !== this.previousSsmGeodeticConnections) {
            this.previousSsmGeodeticConnections = this.model.ssmGeodeticConnections;
            this.removeAllSsmConnections();
            if (this.model.ssmGeodeticConnections) {
                this.addSsmConnection();
            }
        }
    }
    addSsmConnection(filteredIdx?: number) {
        this.addGeodeticConnection('SSM', filteredIdx);
    }
    addBmConnection(filteredIdx?: number) {
        this.addGeodeticConnection('BM', filteredIdx);
    }

    removeSsmConnection(filteredIdx: number) {
        this.removeGeodeticConnection('SSM', filteredIdx);
    }

    removeBmConnection(filteredIdx: number) {
        this.removeGeodeticConnection('BM', filteredIdx);
    }
    addGeodeticConnection(markType: string, filteredIdx?: number) {
        if (filteredIdx) {
            this.model.geodeticConnections.splice(
                this.getGeodeticConnectionIndex(markType, filteredIdx)
                    ? this.getGeodeticConnectionIndex(markType, filteredIdx) + 1
                    : this.model.geodeticConnections.length,
                0,
                {
                    markType: markType
                }
            );
        } else {
            this.model.geodeticConnections.push({
                markType: markType
            });
        }
    }

    removeGeodeticConnection(markType, filteredIdx) {
        this.model.geodeticConnections.splice(this.getGeodeticConnectionIndex(markType, filteredIdx), 1);
        if (this.getGeodeticConnectionsByMarkType(markType).length === 0) {
            this.model.geodeticConnections.splice(0, 0, {markType: markType});
        }
    }

    getGeodeticConnectionsByMarkType(markType) {
        return this.model.geodeticConnections.filter(function (v) {
            return v.markType === markType;
        });
    }

    getGeodeticConnectionIndex(markType: string, filteredIdx: number) {
        return this.model.geodeticConnections
            .map(function (v, i) {
                return {v: v, i: i};
            })
            .filter(function (vi) {
                return vi.v.markType === markType;
            })
            .filter(function (vi, fi) {
                return fi === filteredIdx;
            })[0].i;
    }

    removeAllBmConnections() {
        this.removeAllGeodeticConnections('BM');
    }

    removeAllSsmConnections() {
        this.removeAllGeodeticConnections('SSM');
    }

    removeAllGeodeticConnections(markType: string) {
        if (markType) {
            const newGeodeticConnections = this.model.geodeticConnections.filter(function (v) {
                return v.markType !== markType;
            });
            this.model.geodeticConnections.length = 0;
            Array.prototype.push.apply(this.model.geodeticConnections, newGeodeticConnections);
        }
    }

    toOptions(values: string[]) {
        return values.map(function (v) {
            return {
                name: v,
                value: v === 'Yes'
            };
        });
    }

    yesNoOptions() {
        return this.toOptions(['Yes', 'No']);
    }

    geodeticConnectionsFiltered(type: string): [] {
        return type === 'SSM'
            ? this.model.geodeticConnections.filter(v => v.markType == type)
            : this.model.geodeticConnections.filter(v => v.markType == 'BM');
    }

    onSpecialSurveyAreaChange(option: string) {
        this.model.specialSurveyArea = option;
    }

    onSsmConnectionsChange(option: boolean) {
        this.model.ssmGeodeticConnections = option;
        option && this.geodeticConnectionsFiltered('SSM').length === 0 ? this.addSsmConnection() : null;
    }

    onBenchMarkConnectionsChange(option: boolean) {
        this.model.benchmarkConnections = option;
        option && this.geodeticConnectionsFiltered('BM').length === 0 ? this.addBmConnection() : null;
    }

    onUnnamedGeodeticConnectionsChange(option: string) {
        this.model.unnamedGeodeticConnection = option;
    }

    onSsmGeodeticConnectionsChange(newValue: string, index: number) {
        this.model.geodeticConnections[this.getGeodeticConnectionIndex('SSM', index)].name = newValue;
    }

    onBmGeodeticConnectionsChange(newValue: string, index: number) {
        this.model.geodeticConnections[this.getGeodeticConnectionIndex('BM', index)].name = newValue;
    }
}
